import * as ambassadorWixFormsAiV1InteractiveFormSession from './forms-ai-v1-interactive-form-session-interactive-form-sessions.http.js';
import * as ambassadorWixFormsAiV1InteractiveFormSessionTypes from './forms-ai-v1-interactive-form-session-interactive-form-sessions.types.js';
import * as ambassadorWixFormsAiV1InteractiveFormSessionUniversalTypes from './forms-ai-v1-interactive-form-session-interactive-form-sessions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createInteractiveFormSession(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFormsAiV1InteractiveFormSessionUniversalTypes.CreateInteractiveFormSessionRequest,
  ambassadorWixFormsAiV1InteractiveFormSessionTypes.CreateInteractiveFormSessionRequest,
  ambassadorWixFormsAiV1InteractiveFormSessionUniversalTypes.CreateInteractiveFormSessionResponse,
  ambassadorWixFormsAiV1InteractiveFormSessionTypes.CreateInteractiveFormSessionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFormsAiV1InteractiveFormSession.createInteractiveFormSession(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/interactive-form-sessions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createInteractiveFormSessionStreamed(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFormsAiV1InteractiveFormSessionUniversalTypes.CreateInteractiveFormSessionStreamedRequest,
  ambassadorWixFormsAiV1InteractiveFormSessionTypes.CreateInteractiveFormSessionStreamedRequest,
  ambassadorWixFormsAiV1InteractiveFormSessionUniversalTypes.CreateInteractiveFormSessionStreamedResponse,
  ambassadorWixFormsAiV1InteractiveFormSessionTypes.CreateInteractiveFormSessionStreamedResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFormsAiV1InteractiveFormSession.createInteractiveFormSessionStreamed(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/interactive-form-sessions/create-streamed',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function sendUserMessage(): __PublicMethodMetaInfo<
  'POST',
  { interactiveFormSessionId: string },
  ambassadorWixFormsAiV1InteractiveFormSessionUniversalTypes.SendUserMessageRequest,
  ambassadorWixFormsAiV1InteractiveFormSessionTypes.SendUserMessageRequest,
  ambassadorWixFormsAiV1InteractiveFormSessionUniversalTypes.SendUserMessageResponse,
  ambassadorWixFormsAiV1InteractiveFormSessionTypes.SendUserMessageResponse
> {
  const payload = {
    interactiveFormSessionId: ':interactiveFormSessionId',
  } as any;

  const getRequestOptions =
    ambassadorWixFormsAiV1InteractiveFormSession.sendUserMessage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/interactive-form-sessions/{interactiveFormSessionId}/send-user-message',
    pathParams: { interactiveFormSessionId: 'interactiveFormSessionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function sendUserMessageStreamed(): __PublicMethodMetaInfo<
  'POST',
  { interactiveFormSessionId: string },
  ambassadorWixFormsAiV1InteractiveFormSessionUniversalTypes.SendUserMessageStreamedRequest,
  ambassadorWixFormsAiV1InteractiveFormSessionTypes.SendUserMessageStreamedRequest,
  ambassadorWixFormsAiV1InteractiveFormSessionUniversalTypes.SendUserMessageStreamedResponse,
  ambassadorWixFormsAiV1InteractiveFormSessionTypes.SendUserMessageStreamedResponse
> {
  const payload = {
    interactiveFormSessionId: ':interactiveFormSessionId',
  } as any;

  const getRequestOptions =
    ambassadorWixFormsAiV1InteractiveFormSession.sendUserMessageStreamed(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/interactive-form-sessions/{interactiveFormSessionId}/send-user-message-streamed',
    pathParams: { interactiveFormSessionId: 'interactiveFormSessionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function generateFormSummary(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFormsAiV1InteractiveFormSessionUniversalTypes.GenerateFormSummaryRequest,
  ambassadorWixFormsAiV1InteractiveFormSessionTypes.GenerateFormSummaryRequest,
  ambassadorWixFormsAiV1InteractiveFormSessionUniversalTypes.GenerateFormSummaryResponse,
  ambassadorWixFormsAiV1InteractiveFormSessionTypes.GenerateFormSummaryResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFormsAiV1InteractiveFormSession.generateFormSummary(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/interactive-form-sessions/generate-form-summary',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  InteractiveFormSession as InteractiveFormSessionOriginal,
  Form as FormOriginal,
  FormField as FormFieldOriginal,
  FormFieldStringType as FormFieldStringTypeOriginal,
  FormFieldStringTypeFormatOptionsOneOf as FormFieldStringTypeFormatOptionsOneOfOriginal,
  StringTypeFormatEnumFormat as StringTypeFormatEnumFormatOriginal,
  StringTypeFormatEnumFormatWithLiterals as StringTypeFormatEnumFormatWithLiteralsOriginal,
  StringErrorMessages as StringErrorMessagesOriginal,
  DateTimeAdvancedConstraints as DateTimeAdvancedConstraintsOriginal,
  Availability as AvailabilityOriginal,
  DateRange as DateRangeOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  StringTypeDateTimeConstraints as StringTypeDateTimeConstraintsOriginal,
  StringTypePhoneConstraints as StringTypePhoneConstraintsOriginal,
  StringTypeValidationMessages as StringTypeValidationMessagesOriginal,
  FormFieldNumberType as FormFieldNumberTypeOriginal,
  NumberErrorMessages as NumberErrorMessagesOriginal,
  IntegerType as IntegerTypeOriginal,
  FormFieldBooleanType as FormFieldBooleanTypeOriginal,
  BooleanErrorMessages as BooleanErrorMessagesOriginal,
  FormFieldArrayType as FormFieldArrayTypeOriginal,
  FormFieldObjectType as FormFieldObjectTypeOriginal,
  ObjectTypePropertiesType as ObjectTypePropertiesTypeOriginal,
  ObjectTypePropertiesTypePropertiesTypeOneOf as ObjectTypePropertiesTypePropertiesTypeOneOfOriginal,
  ObjectErrorMessages as ObjectErrorMessagesOriginal,
  ArrayTypeArrayItems as ArrayTypeArrayItemsOriginal,
  ArrayTypeArrayItemsItemsOneOf as ArrayTypeArrayItemsItemsOneOfOriginal,
  ArrayErrorMessages as ArrayErrorMessagesOriginal,
  PredefinedValidation as PredefinedValidationOriginal,
  PredefinedValidationFormatOptionsOneOf as PredefinedValidationFormatOptionsOneOfOriginal,
  ValidationFormat as ValidationFormatOriginal,
  ValidationFormatWithLiterals as ValidationFormatWithLiteralsOriginal,
  PaymentType as PaymentTypeOriginal,
  ProductType as ProductTypeOriginal,
  ProductTypeWithLiterals as ProductTypeWithLiteralsOriginal,
  PriceType as PriceTypeOriginal,
  PriceTypeWithLiterals as PriceTypeWithLiteralsOriginal,
  QuantityLimit as QuantityLimitOriginal,
  FixedPriceOptions as FixedPriceOptionsOriginal,
  DynamicPriceOptions as DynamicPriceOptionsOriginal,
  Product as ProductOriginal,
  ProductPriceOptionsOneOf as ProductPriceOptionsOneOfOriginal,
  MultilineAddressValidation as MultilineAddressValidationOriginal,
  FieldOverrides as FieldOverridesOriginal,
  FieldsOverrides as FieldsOverridesOriginal,
  ObjectArrayType as ObjectArrayTypeOriginal,
  NestedFormFieldOverrides as NestedFormFieldOverridesOriginal,
  Validation as ValidationOriginal,
  ValidationValidationOneOf as ValidationValidationOneOfOriginal,
  DataExtensionsDetails as DataExtensionsDetailsOriginal,
  NestedFormOverrides as NestedFormOverridesOriginal,
  Field as FieldOriginal,
  FieldFieldTypeOptionsOneOf as FieldFieldTypeOptionsOneOfOriginal,
  FieldType as FieldTypeOriginal,
  FieldTypeWithLiterals as FieldTypeWithLiteralsOriginal,
  InputField as InputFieldOriginal,
  InputFieldInputTypeOptionsOneOf as InputFieldInputTypeOptionsOneOfOriginal,
  StringCorrectAnswersList as StringCorrectAnswersListOriginal,
  StringType as StringTypeOriginal,
  StringTypeFormatOptionsOneOf as StringTypeFormatOptionsOneOfOriginal,
  FormatEnumFormat as FormatEnumFormatOriginal,
  FormatEnumFormatWithLiterals as FormatEnumFormatWithLiteralsOriginal,
  DateTimeConstraints as DateTimeConstraintsOriginal,
  PhoneConstraints as PhoneConstraintsOriginal,
  ValidationMessages as ValidationMessagesOriginal,
  StringComponentType as StringComponentTypeOriginal,
  StringComponentTypeWithLiterals as StringComponentTypeWithLiteralsOriginal,
  StringQuizFieldSettings as StringQuizFieldSettingsOriginal,
  TextInput as TextInputOriginal,
  RichContent as RichContentOriginal,
  Node as NodeOriginal,
  NodeDataOneOf as NodeDataOneOfOriginal,
  NodeType as NodeTypeOriginal,
  NodeTypeWithLiterals as NodeTypeWithLiteralsOriginal,
  NodeStyle as NodeStyleOriginal,
  ButtonData as ButtonDataOriginal,
  BackgroundType as BackgroundTypeOriginal,
  BackgroundTypeWithLiterals as BackgroundTypeWithLiteralsOriginal,
  Gradient as GradientOriginal,
  GradientType as GradientTypeOriginal,
  GradientTypeWithLiterals as GradientTypeWithLiteralsOriginal,
  Stop as StopOriginal,
  Border as BorderOriginal,
  Colors as ColorsOriginal,
  Background as BackgroundOriginal,
  PluginContainerData as PluginContainerDataOriginal,
  WidthType as WidthTypeOriginal,
  WidthTypeWithLiterals as WidthTypeWithLiteralsOriginal,
  PluginContainerDataWidth as PluginContainerDataWidthOriginal,
  PluginContainerDataWidthDataOneOf as PluginContainerDataWidthDataOneOfOriginal,
  PluginContainerDataAlignment as PluginContainerDataAlignmentOriginal,
  PluginContainerDataAlignmentWithLiterals as PluginContainerDataAlignmentWithLiteralsOriginal,
  Spoiler as SpoilerOriginal,
  Height as HeightOriginal,
  ButtonDataType as ButtonDataTypeOriginal,
  ButtonDataTypeWithLiterals as ButtonDataTypeWithLiteralsOriginal,
  Styles as StylesOriginal,
  Link as LinkOriginal,
  LinkDataOneOf as LinkDataOneOfOriginal,
  LinkTarget as LinkTargetOriginal,
  LinkTargetWithLiterals as LinkTargetWithLiteralsOriginal,
  Rel as RelOriginal,
  CodeBlockData as CodeBlockDataOriginal,
  TextStyle as TextStyleOriginal,
  TextAlignment as TextAlignmentOriginal,
  TextAlignmentWithLiterals as TextAlignmentWithLiteralsOriginal,
  DividerData as DividerDataOriginal,
  LineStyle as LineStyleOriginal,
  LineStyleWithLiterals as LineStyleWithLiteralsOriginal,
  Width as WidthOriginal,
  WidthWithLiterals as WidthWithLiteralsOriginal,
  DividerDataAlignment as DividerDataAlignmentOriginal,
  DividerDataAlignmentWithLiterals as DividerDataAlignmentWithLiteralsOriginal,
  FileData as FileDataOriginal,
  ViewMode as ViewModeOriginal,
  ViewModeWithLiterals as ViewModeWithLiteralsOriginal,
  FileSource as FileSourceOriginal,
  FileSourceDataOneOf as FileSourceDataOneOfOriginal,
  PDFSettings as PDFSettingsOriginal,
  GalleryData as GalleryDataOriginal,
  Media as MediaOriginal,
  ItemImage as ItemImageOriginal,
  Video as VideoOriginal,
  Item as ItemOriginal,
  ItemDataOneOf as ItemDataOneOfOriginal,
  GalleryOptions as GalleryOptionsOriginal,
  LayoutType as LayoutTypeOriginal,
  LayoutTypeWithLiterals as LayoutTypeWithLiteralsOriginal,
  Orientation as OrientationOriginal,
  OrientationWithLiterals as OrientationWithLiteralsOriginal,
  Crop as CropOriginal,
  CropWithLiterals as CropWithLiteralsOriginal,
  ThumbnailsAlignment as ThumbnailsAlignmentOriginal,
  ThumbnailsAlignmentWithLiterals as ThumbnailsAlignmentWithLiteralsOriginal,
  GalleryOptionsLayout as GalleryOptionsLayoutOriginal,
  ItemStyle as ItemStyleOriginal,
  Thumbnails as ThumbnailsOriginal,
  GIFData as GIFDataOriginal,
  GIF as GIFOriginal,
  GIFType as GIFTypeOriginal,
  GIFTypeWithLiterals as GIFTypeWithLiteralsOriginal,
  HeadingData as HeadingDataOriginal,
  HTMLData as HTMLDataOriginal,
  HTMLDataDataOneOf as HTMLDataDataOneOfOriginal,
  Source as SourceOriginal,
  SourceWithLiterals as SourceWithLiteralsOriginal,
  ImageData as ImageDataOriginal,
  StylesBorder as StylesBorderOriginal,
  ImageDataStyles as ImageDataStylesOriginal,
  LinkPreviewData as LinkPreviewDataOriginal,
  StylesPosition as StylesPositionOriginal,
  StylesPositionWithLiterals as StylesPositionWithLiteralsOriginal,
  LinkPreviewDataStyles as LinkPreviewDataStylesOriginal,
  MapData as MapDataOriginal,
  MapSettings as MapSettingsOriginal,
  MapType as MapTypeOriginal,
  MapTypeWithLiterals as MapTypeWithLiteralsOriginal,
  ParagraphData as ParagraphDataOriginal,
  PollData as PollDataOriginal,
  ViewRole as ViewRoleOriginal,
  ViewRoleWithLiterals as ViewRoleWithLiteralsOriginal,
  VoteRole as VoteRoleOriginal,
  VoteRoleWithLiterals as VoteRoleWithLiteralsOriginal,
  Permissions as PermissionsOriginal,
  PollOption as PollOptionOriginal,
  Settings as SettingsOriginal,
  PollLayoutType as PollLayoutTypeOriginal,
  PollLayoutTypeWithLiterals as PollLayoutTypeWithLiteralsOriginal,
  PollLayoutDirection as PollLayoutDirectionOriginal,
  PollLayoutDirectionWithLiterals as PollLayoutDirectionWithLiteralsOriginal,
  PollLayout as PollLayoutOriginal,
  OptionLayout as OptionLayoutOriginal,
  PollDesignBackgroundType as PollDesignBackgroundTypeOriginal,
  PollDesignBackgroundTypeWithLiterals as PollDesignBackgroundTypeWithLiteralsOriginal,
  BackgroundGradient as BackgroundGradientOriginal,
  PollDesignBackground as PollDesignBackgroundOriginal,
  PollDesignBackgroundBackgroundOneOf as PollDesignBackgroundBackgroundOneOfOriginal,
  PollDesign as PollDesignOriginal,
  OptionDesign as OptionDesignOriginal,
  Poll as PollOriginal,
  PollDataLayout as PollDataLayoutOriginal,
  Design as DesignOriginal,
  TextData as TextDataOriginal,
  Decoration as DecorationOriginal,
  DecorationDataOneOf as DecorationDataOneOfOriginal,
  DecorationType as DecorationTypeOriginal,
  DecorationTypeWithLiterals as DecorationTypeWithLiteralsOriginal,
  AnchorData as AnchorDataOriginal,
  ColorData as ColorDataOriginal,
  LinkData as LinkDataOriginal,
  MentionData as MentionDataOriginal,
  FontSizeData as FontSizeDataOriginal,
  FontType as FontTypeOriginal,
  FontTypeWithLiterals as FontTypeWithLiteralsOriginal,
  SpoilerData as SpoilerDataOriginal,
  FontFamilyData as FontFamilyDataOriginal,
  AppEmbedData as AppEmbedDataOriginal,
  AppEmbedDataAppDataOneOf as AppEmbedDataAppDataOneOfOriginal,
  Position as PositionOriginal,
  PositionWithLiterals as PositionWithLiteralsOriginal,
  AspectRatio as AspectRatioOriginal,
  AspectRatioWithLiterals as AspectRatioWithLiteralsOriginal,
  Resizing as ResizingOriginal,
  ResizingWithLiterals as ResizingWithLiteralsOriginal,
  Placement as PlacementOriginal,
  PlacementWithLiterals as PlacementWithLiteralsOriginal,
  CardStylesType as CardStylesTypeOriginal,
  CardStylesTypeWithLiterals as CardStylesTypeWithLiteralsOriginal,
  CardStylesAlignment as CardStylesAlignmentOriginal,
  CardStylesAlignmentWithLiterals as CardStylesAlignmentWithLiteralsOriginal,
  Layout as LayoutOriginal,
  LayoutWithLiterals as LayoutWithLiteralsOriginal,
  AppType as AppTypeOriginal,
  AppTypeWithLiterals as AppTypeWithLiteralsOriginal,
  BookingData as BookingDataOriginal,
  EventData as EventDataOriginal,
  ButtonStyles as ButtonStylesOriginal,
  ImageStyles as ImageStylesOriginal,
  RibbonStyles as RibbonStylesOriginal,
  CardStyles as CardStylesOriginal,
  PricingData as PricingDataOriginal,
  VideoData as VideoDataOriginal,
  PlaybackOptions as PlaybackOptionsOriginal,
  EmbedData as EmbedDataOriginal,
  Oembed as OembedOriginal,
  CollapsibleListData as CollapsibleListDataOriginal,
  InitialExpandedItems as InitialExpandedItemsOriginal,
  InitialExpandedItemsWithLiterals as InitialExpandedItemsWithLiteralsOriginal,
  Direction as DirectionOriginal,
  DirectionWithLiterals as DirectionWithLiteralsOriginal,
  TableData as TableDataOriginal,
  Dimensions as DimensionsOriginal,
  TableCellData as TableCellDataOriginal,
  VerticalAlignment as VerticalAlignmentOriginal,
  VerticalAlignmentWithLiterals as VerticalAlignmentWithLiteralsOriginal,
  CellStyle as CellStyleOriginal,
  BorderColors as BorderColorsOriginal,
  BorderWidths as BorderWidthsOriginal,
  NullValue as NullValueOriginal,
  NullValueWithLiterals as NullValueWithLiteralsOriginal,
  ListValue as ListValueOriginal,
  AudioData as AudioDataOriginal,
  OrderedListData as OrderedListDataOriginal,
  BulletedListData as BulletedListDataOriginal,
  BlockquoteData as BlockquoteDataOriginal,
  CaptionData as CaptionDataOriginal,
  LayoutData as LayoutDataOriginal,
  ImageScalingScaling as ImageScalingScalingOriginal,
  ImageScalingScalingWithLiterals as ImageScalingScalingWithLiteralsOriginal,
  LayoutDataImagePosition as LayoutDataImagePositionOriginal,
  LayoutDataImagePositionWithLiterals as LayoutDataImagePositionWithLiteralsOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  LayoutDataBackgroundType as LayoutDataBackgroundTypeOriginal,
  LayoutDataBackgroundTypeWithLiterals as LayoutDataBackgroundTypeWithLiteralsOriginal,
  BackdropType as BackdropTypeOriginal,
  BackdropTypeWithLiterals as BackdropTypeWithLiteralsOriginal,
  LayoutDataBackgroundImage as LayoutDataBackgroundImageOriginal,
  VerticalAlignmentAlignment as VerticalAlignmentAlignmentOriginal,
  VerticalAlignmentAlignmentWithLiterals as VerticalAlignmentAlignmentWithLiteralsOriginal,
  ResponsivenessBehaviour as ResponsivenessBehaviourOriginal,
  ResponsivenessBehaviourWithLiterals as ResponsivenessBehaviourWithLiteralsOriginal,
  DesignTarget as DesignTargetOriginal,
  DesignTargetWithLiterals as DesignTargetWithLiteralsOriginal,
  Banner as BannerOriginal,
  LayoutDataBackground as LayoutDataBackgroundOriginal,
  Backdrop as BackdropOriginal,
  LayoutCellData as LayoutCellDataOriginal,
  ShapeData as ShapeDataOriginal,
  ShapeDataStyles as ShapeDataStylesOriginal,
  CardData as CardDataOriginal,
  Scaling as ScalingOriginal,
  ScalingWithLiterals as ScalingWithLiteralsOriginal,
  ImagePositionPosition as ImagePositionPositionOriginal,
  ImagePositionPositionWithLiterals as ImagePositionPositionWithLiteralsOriginal,
  CardDataBackgroundType as CardDataBackgroundTypeOriginal,
  CardDataBackgroundTypeWithLiterals as CardDataBackgroundTypeWithLiteralsOriginal,
  CardDataBackground as CardDataBackgroundOriginal,
  BackgroundImage as BackgroundImageOriginal,
  TocData as TocDataOriginal,
  ListStyle as ListStyleOriginal,
  ListStyleWithLiterals as ListStyleWithLiteralsOriginal,
  Indentation as IndentationOriginal,
  IndentationWithLiterals as IndentationWithLiteralsOriginal,
  SmartBlockData as SmartBlockDataOriginal,
  SmartBlockDataType as SmartBlockDataTypeOriginal,
  SmartBlockDataTypeWithLiterals as SmartBlockDataTypeWithLiteralsOriginal,
  ColumnSize as ColumnSizeOriginal,
  ColumnSizeWithLiterals as ColumnSizeWithLiteralsOriginal,
  SmartBlockCellData as SmartBlockCellDataOriginal,
  Metadata as MetadataOriginal,
  DocumentStyle as DocumentStyleOriginal,
  TextNodeStyle as TextNodeStyleOriginal,
  MediaItem as MediaItemOriginal,
  MediaItemMediaOneOf as MediaItemMediaOneOfOriginal,
  Image as ImageOriginal,
  MediaSettings as MediaSettingsOriginal,
  ImagePosition as ImagePositionOriginal,
  ImagePositionWithLiterals as ImagePositionWithLiteralsOriginal,
  Alignment as AlignmentOriginal,
  AlignmentWithLiterals as AlignmentWithLiteralsOriginal,
  ImageFit as ImageFitOriginal,
  ImageFitWithLiterals as ImageFitWithLiteralsOriginal,
  RadioGroup as RadioGroupOriginal,
  RadioGroupOption as RadioGroupOptionOriginal,
  CustomOption as CustomOptionOriginal,
  NumberOfColumns as NumberOfColumnsOriginal,
  NumberOfColumnsWithLiterals as NumberOfColumnsWithLiteralsOriginal,
  Dropdown as DropdownOriginal,
  DropdownOption as DropdownOptionOriginal,
  DateTimeInput as DateTimeInputOriginal,
  PhoneInput as PhoneInputOriginal,
  DateInput as DateInputOriginal,
  TimeInput as TimeInputOriginal,
  DatePicker as DatePickerOriginal,
  FirstDayOfWeek as FirstDayOfWeekOriginal,
  FirstDayOfWeekWithLiterals as FirstDayOfWeekWithLiteralsOriginal,
  ServicesDropdown as ServicesDropdownOriginal,
  ServiceOption as ServiceOptionOriginal,
  Password as PasswordOriginal,
  NumberCorrectAnswersList as NumberCorrectAnswersListOriginal,
  NumberType as NumberTypeOriginal,
  NumberComponentType as NumberComponentTypeOriginal,
  NumberComponentTypeWithLiterals as NumberComponentTypeWithLiteralsOriginal,
  NumberQuizFieldSettings as NumberQuizFieldSettingsOriginal,
  NumberInput as NumberInputOriginal,
  RatingInput as RatingInputOriginal,
  BooleanType as BooleanTypeOriginal,
  BooleanComponentType as BooleanComponentTypeOriginal,
  BooleanComponentTypeWithLiterals as BooleanComponentTypeWithLiteralsOriginal,
  Checkbox as CheckboxOriginal,
  CorrectAnswersList as CorrectAnswersListOriginal,
  ArrayType as ArrayTypeOriginal,
  ItemType as ItemTypeOriginal,
  ItemTypeWithLiterals as ItemTypeWithLiteralsOriginal,
  ObjectType as ObjectTypeOriginal,
  PropertiesTypeEnum as PropertiesTypeEnumOriginal,
  PropertiesTypeEnumWithLiterals as PropertiesTypeEnumWithLiteralsOriginal,
  PropertiesType as PropertiesTypeOriginal,
  PropertiesTypePropertiesTypeOptionsOneOf as PropertiesTypePropertiesTypeOptionsOneOfOriginal,
  ArrayItems as ArrayItemsOriginal,
  ArrayItemsItemTypeOptionsOneOf as ArrayItemsItemTypeOptionsOneOfOriginal,
  ArrayComponentType as ArrayComponentTypeOriginal,
  ArrayComponentTypeWithLiterals as ArrayComponentTypeWithLiteralsOriginal,
  QuizFieldSettings as QuizFieldSettingsOriginal,
  CheckboxGroup as CheckboxGroupOriginal,
  CheckboxGroupOption as CheckboxGroupOptionOriginal,
  ComponentsTags as ComponentsTagsOriginal,
  TagsOption as TagsOptionOriginal,
  ServicesCheckboxGroup as ServicesCheckboxGroupOriginal,
  WixFileComponentType as WixFileComponentTypeOriginal,
  WixFileComponentTypeWithLiterals as WixFileComponentTypeWithLiteralsOriginal,
  FileType as FileTypeOriginal,
  UploadFileFormat as UploadFileFormatOriginal,
  UploadFileFormatWithLiterals as UploadFileFormatWithLiteralsOriginal,
  FileUpload as FileUploadOriginal,
  Signature as SignatureOriginal,
  PaymentComponentType as PaymentComponentTypeOriginal,
  PaymentComponentTypeWithLiterals as PaymentComponentTypeWithLiteralsOriginal,
  ProductCheckboxGroup as ProductCheckboxGroupOriginal,
  ProductCheckboxGroupOption as ProductCheckboxGroupOptionOriginal,
  DonationInput as DonationInputOriginal,
  DonationInputOption as DonationInputOptionOriginal,
  PaymentInput as PaymentInputOriginal,
  FixedPayment as FixedPaymentOriginal,
  ComponentType as ComponentTypeOriginal,
  ComponentTypeWithLiterals as ComponentTypeWithLiteralsOriginal,
  MultilineAddress as MultilineAddressOriginal,
  DefaultCountryConfigType as DefaultCountryConfigTypeOriginal,
  DefaultCountryConfigTypeWithLiterals as DefaultCountryConfigTypeWithLiteralsOriginal,
  AddressLine2 as AddressLine2Original,
  DefaultCountryConfig as DefaultCountryConfigOriginal,
  DefaultCountryConfigOptionsOneOf as DefaultCountryConfigOptionsOneOfOriginal,
  FieldsSettings as FieldsSettingsOriginal,
  ObjectArrayComponentType as ObjectArrayComponentTypeOriginal,
  ObjectArrayComponentTypeWithLiterals as ObjectArrayComponentTypeWithLiteralsOriginal,
  Repeater as RepeaterOriginal,
  FormLayout as FormLayoutOriginal,
  BreakPoint as BreakPointOriginal,
  ItemLayout as ItemLayoutOriginal,
  ItemLayoutItemOneOf as ItemLayoutItemOneOfOriginal,
  Group as GroupOriginal,
  Margin as MarginOriginal,
  Section as SectionOriginal,
  SchedulingComponentType as SchedulingComponentTypeOriginal,
  SchedulingComponentTypeWithLiterals as SchedulingComponentTypeWithLiteralsOriginal,
  Appointment as AppointmentOriginal,
  AppointmentFormatInfoOneOf as AppointmentFormatInfoOneOfOriginal,
  Location as LocationOriginal,
  LocationLocationInfoOneOf as LocationLocationInfoOneOfOriginal,
  Format as FormatOriginal,
  FormatWithLiterals as FormatWithLiteralsOriginal,
  MeetingType as MeetingTypeOriginal,
  MeetingTypeWithLiterals as MeetingTypeWithLiteralsOriginal,
  StaffStrategySelection as StaffStrategySelectionOriginal,
  StaffStrategySelectionWithLiterals as StaffStrategySelectionWithLiteralsOriginal,
  InPersonOptions as InPersonOptionsOriginal,
  VideoConferenceOptions as VideoConferenceOptionsOriginal,
  PhoneOptions as PhoneOptionsOriginal,
  InputType as InputTypeOriginal,
  InputTypeWithLiterals as InputTypeWithLiteralsOriginal,
  FormFieldContactInfo as FormFieldContactInfoOriginal,
  FormFieldContactInfoAdditionalInfoOneOf as FormFieldContactInfoAdditionalInfoOneOfOriginal,
  EmailInfoTag as EmailInfoTagOriginal,
  EmailInfoTagWithLiterals as EmailInfoTagWithLiteralsOriginal,
  PhoneInfoTag as PhoneInfoTagOriginal,
  PhoneInfoTagWithLiterals as PhoneInfoTagWithLiteralsOriginal,
  Tag as TagOriginal,
  TagWithLiterals as TagWithLiteralsOriginal,
  ConfirmationLevel as ConfirmationLevelOriginal,
  ConfirmationLevelWithLiterals as ConfirmationLevelWithLiteralsOriginal,
  SubscriptionChannel as SubscriptionChannelOriginal,
  SubscriptionChannelWithLiterals as SubscriptionChannelWithLiteralsOriginal,
  ContactField as ContactFieldOriginal,
  ContactFieldWithLiterals as ContactFieldWithLiteralsOriginal,
  EmailInfo as EmailInfoOriginal,
  PhoneInfo as PhoneInfoOriginal,
  AddressInfo as AddressInfoOriginal,
  CustomFieldInfo as CustomFieldInfoOriginal,
  SubscriptionInfo as SubscriptionInfoOriginal,
  _String as _StringOriginal,
  _StringComponentTypeOptionsOneOf as _StringComponentTypeOptionsOneOfOriginal,
  _Number as _NumberOriginal,
  _NumberComponentTypeOptionsOneOf as _NumberComponentTypeOptionsOneOfOriginal,
  _Boolean as _BooleanOriginal,
  _BooleanComponentTypeOptionsOneOf as _BooleanComponentTypeOptionsOneOfOriginal,
  _Array as _ArrayOriginal,
  _ArrayComponentTypeOptionsOneOf as _ArrayComponentTypeOptionsOneOfOriginal,
  _Object as _ObjectOriginal,
  WixFile as WixFileOriginal,
  WixFileComponentTypeOptionsOneOf as WixFileComponentTypeOptionsOneOfOriginal,
  Payment as PaymentOriginal,
  PaymentComponentTypeOptionsOneOf as PaymentComponentTypeOptionsOneOfOriginal,
  Scheduling as SchedulingOriginal,
  SchedulingComponentTypeOptionsOneOf as SchedulingComponentTypeOptionsOneOfOriginal,
  Address as AddressOriginal,
  AddressComponentTypeOptionsOneOf as AddressComponentTypeOptionsOneOfOriginal,
  ObjectArray as ObjectArrayOriginal,
  ObjectArrayComponentTypeOptionsOneOf as ObjectArrayComponentTypeOptionsOneOfOriginal,
  DisplayField as DisplayFieldOriginal,
  DisplayFieldDisplayFieldTypeOptionsOneOf as DisplayFieldDisplayFieldTypeOptionsOneOfOriginal,
  DisplayFieldType as DisplayFieldTypeOriginal,
  DisplayFieldTypeWithLiterals as DisplayFieldTypeWithLiteralsOriginal,
  RichContentOptions as RichContentOptionsOriginal,
  PageNavigationOptions as PageNavigationOptionsOriginal,
  Step as StepOriginal,
  FormRule as FormRuleOriginal,
  OverrideEntityType as OverrideEntityTypeOriginal,
  OverrideEntityTypeWithLiterals as OverrideEntityTypeWithLiteralsOriginal,
  FormOverride as FormOverrideOriginal,
  FormProperties as FormPropertiesOriginal,
  Kind as KindOriginal,
  KindWithLiterals as KindWithLiteralsOriginal,
  PostSubmissionTriggers as PostSubmissionTriggersOriginal,
  UpsertContact as UpsertContactOriginal,
  V4FormFieldContactInfo as V4FormFieldContactInfoOriginal,
  V4FormFieldContactInfoAdditionalInfoOneOf as V4FormFieldContactInfoAdditionalInfoOneOfOriginal,
  FormFieldContactInfoEmailInfoTag as FormFieldContactInfoEmailInfoTagOriginal,
  FormFieldContactInfoEmailInfoTagWithLiterals as FormFieldContactInfoEmailInfoTagWithLiteralsOriginal,
  FormFieldContactInfoPhoneInfoTag as FormFieldContactInfoPhoneInfoTagOriginal,
  FormFieldContactInfoPhoneInfoTagWithLiterals as FormFieldContactInfoPhoneInfoTagWithLiteralsOriginal,
  AddressInfoTag as AddressInfoTagOriginal,
  AddressInfoTagWithLiterals as AddressInfoTagWithLiteralsOriginal,
  OptInLevel as OptInLevelOriginal,
  OptInLevelWithLiterals as OptInLevelWithLiteralsOriginal,
  FormFieldContactInfoContactField as FormFieldContactInfoContactFieldOriginal,
  FormFieldContactInfoContactFieldWithLiterals as FormFieldContactInfoContactFieldWithLiteralsOriginal,
  FormFieldContactInfoEmailInfo as FormFieldContactInfoEmailInfoOriginal,
  FormFieldContactInfoPhoneInfo as FormFieldContactInfoPhoneInfoOriginal,
  FormFieldContactInfoAddressInfo as FormFieldContactInfoAddressInfoOriginal,
  FormFieldContactInfoCustomFieldInfo as FormFieldContactInfoCustomFieldInfoOriginal,
  FormFieldContactInfoSubscriptionInfo as FormFieldContactInfoSubscriptionInfoOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  NestedForm as NestedFormOriginal,
  LimitationRule as LimitationRuleOriginal,
  SpamFilterProtectionLevel as SpamFilterProtectionLevelOriginal,
  SpamFilterProtectionLevelWithLiterals as SpamFilterProtectionLevelWithLiteralsOriginal,
  RequiredIndicatorProperties as RequiredIndicatorPropertiesOriginal,
  RequiredIndicator as RequiredIndicatorOriginal,
  RequiredIndicatorWithLiterals as RequiredIndicatorWithLiteralsOriginal,
  RequiredIndicatorPlacement as RequiredIndicatorPlacementOriginal,
  RequiredIndicatorPlacementWithLiterals as RequiredIndicatorPlacementWithLiteralsOriginal,
  SubmitSettings as SubmitSettingsOriginal,
  SubmitSettingsSubmitSuccessActionOptionsOneOf as SubmitSettingsSubmitSuccessActionOptionsOneOfOriginal,
  Target as TargetOriginal,
  TargetWithLiterals as TargetWithLiteralsOriginal,
  SubmitSuccessAction as SubmitSuccessActionOriginal,
  SubmitSuccessActionWithLiterals as SubmitSuccessActionWithLiteralsOriginal,
  ThankYouMessageOptions as ThankYouMessageOptionsOriginal,
  RedirectOptions as RedirectOptionsOriginal,
  PopupOptions as PopupOptionsOriginal,
  FieldGroup as FieldGroupOriginal,
  Rule as RuleOriginal,
  ChangeableProperty as ChangeablePropertyOriginal,
  ChangeablePropertyWithLiterals as ChangeablePropertyWithLiteralsOriginal,
  RequiredOptions as RequiredOptionsOriginal,
  HiddenOptions as HiddenOptionsOriginal,
  AllowedValuesOptions as AllowedValuesOptionsOriginal,
  OverrideEntityTypeEnumOverrideEntityType as OverrideEntityTypeEnumOverrideEntityTypeOriginal,
  OverrideEntityTypeEnumOverrideEntityTypeWithLiterals as OverrideEntityTypeEnumOverrideEntityTypeWithLiteralsOriginal,
  FieldOverride as FieldOverrideOriginal,
  FieldOverridePropertyTypeOptionsOneOf as FieldOverridePropertyTypeOptionsOneOfOriginal,
  ConditionNode as ConditionNodeOriginal,
  ConditionNodeNodeOneOf as ConditionNodeNodeOneOfOriginal,
  AndCondition as AndConditionOriginal,
  OrCondition as OrConditionOriginal,
  Condition as ConditionOriginal,
  Operator as OperatorOriginal,
  OperatorWithLiterals as OperatorWithLiteralsOriginal,
  RuleFormOverride as RuleFormOverrideOriginal,
  RuleFormOverrideEntityTypeOptionsOneOf as RuleFormOverrideEntityTypeOptionsOneOfOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  QuizSettings as QuizSettingsOriginal,
  QuizSettingsPassingCriteriaOneOf as QuizSettingsPassingCriteriaOneOfOriginal,
  QuizSettingsResultsDisplayOptionsOneOf as QuizSettingsResultsDisplayOptionsOneOfOriginal,
  ResultsDisplay as ResultsDisplayOriginal,
  ResultsDisplayWithLiterals as ResultsDisplayWithLiteralsOriginal,
  PassFailMessages as PassFailMessagesOriginal,
  ContactAutofill as ContactAutofillOriginal,
  ContactAutofillWithLiterals as ContactAutofillWithLiteralsOriginal,
  SubmissionAccess as SubmissionAccessOriginal,
  SubmissionAccessWithLiterals as SubmissionAccessWithLiteralsOriginal,
  CreateInteractiveFormSessionRequest as CreateInteractiveFormSessionRequestOriginal,
  ClientTime as ClientTimeOriginal,
  CreateInteractiveFormSessionResponse as CreateInteractiveFormSessionResponseOriginal,
  InteractiveFormSessionResponseChunk as InteractiveFormSessionResponseChunkOriginal,
  InteractiveFormSessionResponseChunkOfOneOf as InteractiveFormSessionResponseChunkOfOneOfOriginal,
  ChunkType as ChunkTypeOriginal,
  ChunkTypeWithLiterals as ChunkTypeWithLiteralsOriginal,
  TextDetails as TextDetailsOriginal,
  Style as StyleOriginal,
  StyleWithLiterals as StyleWithLiteralsOriginal,
  TextDataDetails as TextDataDetailsOriginal,
  MultiSelectInputDetails as MultiSelectInputDetailsOriginal,
  Option as OptionOriginal,
  CustomValue as CustomValueOriginal,
  NumberInputDetails as NumberInputDetailsOriginal,
  NumberRangeLimit as NumberRangeLimitOriginal,
  NumberRangeLimitEndOneOf as NumberRangeLimitEndOneOfOriginal,
  SeparatorDetails as SeparatorDetailsOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  SingleSelectInputDetails as SingleSelectInputDetailsOriginal,
  ErrorDetails as ErrorDetailsOriginal,
  SubmissionDetails as SubmissionDetailsOriginal,
  ImportantTextDetails as ImportantTextDetailsOriginal,
  DebugDetails as DebugDetailsOriginal,
  EndOfResponseDetails as EndOfResponseDetailsOriginal,
  FileUploadDetails as FileUploadDetailsOriginal,
  SignatureDetails as SignatureDetailsOriginal,
  MeaningfulInput as MeaningfulInputOriginal,
  CreateInteractiveFormSessionStreamedRequest as CreateInteractiveFormSessionStreamedRequestOriginal,
  CreateInteractiveFormSessionStreamedResponse as CreateInteractiveFormSessionStreamedResponseOriginal,
  SendUserMessageRequest as SendUserMessageRequestOriginal,
  SendUserMessageResponse as SendUserMessageResponseOriginal,
  SendUserMessageStreamedRequest as SendUserMessageStreamedRequestOriginal,
  SendUserMessageStreamedResponse as SendUserMessageStreamedResponseOriginal,
  ConverseRequest as ConverseRequestOriginal,
  ConverseRequestRequestOneOf as ConverseRequestRequestOneOfOriginal,
  GetStateRequest as GetStateRequestOriginal,
  CallToolsRequest as CallToolsRequestOriginal,
  Call as CallOriginal,
  RelayAssistantMessageRequest as RelayAssistantMessageRequestOriginal,
  UsageRequest as UsageRequestOriginal,
  Usage as UsageOriginal,
  ConverseResponse as ConverseResponseOriginal,
  ConverseResponseResponseOneOf as ConverseResponseResponseOneOfOriginal,
  GetStateResponse as GetStateResponseOriginal,
  Tool as ToolOriginal,
  ContextMessage as ContextMessageOriginal,
  ContextMessageOptionsOneOf as ContextMessageOptionsOneOfOriginal,
  Role as RoleOriginal,
  RoleWithLiterals as RoleWithLiteralsOriginal,
  UserOptions as UserOptionsOriginal,
  AssistantOptions as AssistantOptionsOriginal,
  FunctionCallOptions as FunctionCallOptionsOriginal,
  FunctionCallOutputOptions as FunctionCallOutputOptionsOriginal,
  DeveloperOptions as DeveloperOptionsOriginal,
  CallToolsResponse as CallToolsResponseOriginal,
  Response as ResponseOriginal,
  AcknowledgmentResponse as AcknowledgmentResponseOriginal,
  OutputInteractiveFormSessionStreamedRequest as OutputInteractiveFormSessionStreamedRequestOriginal,
  OutputInteractiveFormSessionStreamedResponse as OutputInteractiveFormSessionStreamedResponseOriginal,
  ReportConversationRequest as ReportConversationRequestOriginal,
  ReportConversationResponse as ReportConversationResponseOriginal,
  GenerateFormSummaryRequest as GenerateFormSummaryRequestOriginal,
  GenerateFormSummaryResponse as GenerateFormSummaryResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  SendUserMessageApplicationErrors as SendUserMessageApplicationErrorsOriginal,
  SendUserMessageStreamedApplicationErrors as SendUserMessageStreamedApplicationErrorsOriginal,
  GenerateFormSummaryApplicationErrors as GenerateFormSummaryApplicationErrorsOriginal,
} from './forms-ai-v1-interactive-form-session-interactive-form-sessions.types.js';
